import type {
  LocaleContentLinkPagination,
  ProductTypeIdentifier,
} from "../graphql"

export const getIsWebGamesProduct = (productType: ProductTypeIdentifier) => {
  const types: ProductTypeIdentifier[] = [
    "fast",
    "assessment",
    "process_on_web",
    "fast_survey",
    "dialogue",
  ]
  return types.includes(productType)
}

export const getIsLeaderboardProduct = (productType: ProductTypeIdentifier) => {
  const types: ProductTypeIdentifier[] = [
    "behavior",
    "process",
    "skill",
    "operations",
    "workflow",
  ]
  return types.includes(productType)
}

export const getProductLink = (
  productId: number | string,
  productType: ProductTypeIdentifier
) => {
  if (getIsLeaderboardProduct(productType)) {
    return `sim/${productId}`
  }
  if (productType === "activity") {
    return `activity/${productId}`
  }
  if (productType === "meet") {
    return `event/${productId}`
  }
  return `product/${productId}`
}

export const getLocalizedPDFLink = ({
  locale,
  uploads,
  contentLink,
}: {
  locale: string | undefined
  uploads: { locale: string; url: string }[]
  contentLink: string
}) => {
  return (
    uploads.find((upload) => upload.locale === locale)?.url ??
    uploads[0]?.url ??
    contentLink
  )
}

export const getPreferredContentLink = ({
  locale,
  localeContentLinks,
  contentLink,
}: {
  locale: string | undefined
  localeContentLinks: Pick<LocaleContentLinkPagination, "nodes">
  contentLink: string
}) => {
  return (
    localeContentLinks.nodes.find((upload) => upload.locale === locale)?.link ??
    localeContentLinks.nodes[0]?.link ??
    contentLink
  )
}

export const getFileDownloadLink = ({
  locale,
  uploads,
}: {
  locale: string | undefined
  uploads: {
    locale: string
    downloadUrl: string
  }[]
}) => {
  const upload = uploads.find((upload) => upload.locale === locale)
  return upload?.downloadUrl ?? null
}
